require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-region-افريقيا.json") })
        }
      }, "path---ar-eg-region-افريقيا");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-region-افريقيا!./.cache/json/ar-eg-region-افريقيا.json
// module id = 442
// module chunks = 231608221292675